<div class="summary-container">
    <div class="summary-button" (click)="manageSummary()" >
      {{summary ? "Hide Summary" : "Show Summary"}}
      <i class="fal" [ngClass]="{'fa-chevron-up': summary, 'fa-chevron-down': !summary}"></i>
    </div>
  
    <div class="summary-group" *ngIf="summary">
  
      <ng-content></ng-content>
    </div>
  </div>